import { render, staticRenderFns } from "./DialogProductIntro.vue?vue&type=template&id=01c51e96&scoped=true&"
import script from "./DialogProductIntro.vue?vue&type=script&lang=js&"
export * from "./DialogProductIntro.vue?vue&type=script&lang=js&"
import style0 from "./DialogProductIntro.vue?vue&type=style&index=0&id=01c51e96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c51e96",
  null
  
)

export default component.exports